export default "__VITE_ASSET__BIqzqbqU__"